import SuppliersAPI from 'dashboard/api/pipelines/suppliers';

const state = {
  records: [],
  uiFlags: { isFetching: false, isCreating: false, isUpdating: false, isDeleting: false },
};

export const getters = {
  getSuppliers: _state => _state.records,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  get: async ({ commit }, { accountId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await SuppliersAPI.get(accountId);
      commit('SET_ITEMS', response.data?.data || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, { accountId, supplier }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await SuppliersAPI.create(accountId, supplier);
      commit('ADD_ITEM', response.data?.data || response.data);
      return response.data?.data || response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { accountId, id, supplier }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await SuppliersAPI.update(accountId, id, supplier);
      commit('UPDATE_ITEM', response.data?.data || response.data);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit }, { accountId, id }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await SuppliersAPI.delete(accountId, id);
      commit('DELETE_ITEM', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG: (_state, data) => { _state.uiFlags = { ..._state.uiFlags, ...data }; },
  SET_ITEMS: (_state, items) => { _state.records = Array.isArray(items) ? items : []; },
  ADD_ITEM: (_state, item) => { if (item?.id) _state.records.push(item); },
  UPDATE_ITEM: (_state, item) => {
    const idx = _state.records.findIndex(r => r.id === item.id);
    if (idx !== -1) _state.records[idx] = { ..._state.records[idx], ...item };
  },
  DELETE_ITEM: (_state, id) => { _state.records = _state.records.filter(r => r.id !== id); },
};

export default { namespaced: true, state, getters, actions, mutations };
